module.exports = __webpack_public_path__ + "img/touxiang.5e364f48.png";